// src/components/brandCustomization/shared/CustomizationCard.jsx
import React from 'react';

/**
 * CustomizationCard - Card contenedor para secciones de personalización
 */
const CustomizationCard = ({
    title,
    description,
    icon = null,
    isActive = true,
    onToggleActive = null,
    children,
    badge = null,
    className = ''
}) => {
    const IconComponent = icon;

    return (
        <div className={`bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden ${className}`}>
            {/* Header */}
            <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
                <div className="flex items-start justify-between">
                    <div className="flex items-center flex-1">
                        {IconComponent && (
                            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                                <IconComponent className="text-blue-600 text-lg" />
                            </div>
                        )}
                        <div>
                            <div className="flex items-center gap-2">
                                <h3 className="text-lg font-semibold text-gray-900">
                                    {title}
                                </h3>
                                {badge && (
                                    <span className="px-2 py-0.5 text-xs font-semibold bg-blue-100 text-blue-600 rounded">
                                        {badge}
                                    </span>
                                )}
                            </div>
                            {description && (
                                <p className="text-sm text-gray-600 mt-1">
                                    {description}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* Toggle de activación */}
                    {onToggleActive && (
                        <div className="ml-4">
                            <button
                                onClick={() => onToggleActive(!isActive)}
                                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${isActive ? 'bg-blue-600' : 'bg-gray-300'
                                    }`}
                            >
                                <span
                                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${isActive ? 'translate-x-6' : 'translate-x-1'
                                        }`}
                                />
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Content */}
            <div className="px-6 py-6">
                {children}
            </div>
        </div>
    );
};

export default CustomizationCard;
